import { Link } from '@/i18n/navigation'
import { MouseEvent, PropsWithChildren } from 'react'

type AnchorLinkProps = PropsWithChildren<{
  href: string
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void
}>

function AnchorLink({ href, onClick, children }: AnchorLinkProps) {
  return (
    <Link
      href={href}
      target={href.startsWith('#') ? '' : '_blank'}
      scroll={href.startsWith('#') ? false : true}
      onClick={(e) => {
        onClick?.(e)
        // 🥷🏼 use this way to scroll to the element
        // 🥷🏼 instead of using the scroll prop
        if (href.startsWith('#')) {
          e.preventDefault()
          const element = document.getElementById(href.slice(1))
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
          }

          e.currentTarget.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          })
        }
      }}
    >
      {children}
    </Link>
  )
}

export default AnchorLink
